import * as React from 'react';

import BodyWrapper, { LayoutTypes } from '../layout/BodyWrapper';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import MediumButton from '../styleguide/MediumButton';
import PhoneInput from 'react-phone-number-input';
// { isPossiblePhoneNumber, parsePhoneNumber }

import styles from './AcceptReferralCode.module.css';

const AcceptReferralCode = () => {

  const [telNumber, setTelNumber] = React.useState();

  // handle user input
  const onPhoneInputChange = (value) => {
    setTelNumber(value);
    //setTelNumberError(false);
    //setVerifyCodeError(false); 
  };
  
  return (
    <BodyWrapper pageLayout={LayoutTypes.Narrow}>
      <div className={styles.referralWrap}>
        <PrimaryHeader isCentered text="Get $16 in Zip Run credit" />
  
        <div className={styles.instructions}>
          Enter your phone number to claim credit:
        </div>

        <PhoneInput
              id="tel_number"
              defaultCountry="US"
              placeholder="Enter phone number"
              value={telNumber}
              onChange={(value) =>{ onPhoneInputChange(value) }} />
   
        <MediumButton text="Submit" handleClick={() => {}} /> 
      </div>
    </BodyWrapper> 
  );
};

export default AcceptReferralCode;